<script setup>

const { messageErreur } = defineProps({
    messageErreur: String
});

</script>

<template>
    <div 
        class="composant-saisie"
        :class="{'erreur-saisie': messageErreur?.length > 0}"
        v-tooltip="messageErreur">
        <slot />
    </div>
</template>

<style scoped>

.composant-saisie {
    display: grid;
}

</style>